import { MeshLambertMaterial } from 'three';
class DefaultMaterial {
    constructor() {
        this._defaultMaterial = new MeshLambertMaterial({ color: 0xcccccc });
    }
    get() {
        return this._defaultMaterial;
    }
}
export default DefaultMaterial;
//# sourceMappingURL=defaultMaterial.js.map